var magicStyles = [":host{display:contents}.experiment{display:contents}"];

export default magicStyles;
